import axios from 'axios'

const key = 'key9UG3ti2B4w5VUw'

export function createCompany(payload) {
    const url = `https://api.airtable.com/v0/appu2mfw4F1eCE4Ah/Companies`
    return axios({
            headers: {
                Authorization: `Bearer ${key}`,
                "Content-Type": `application/json`
            },
            method: 'post',
            url,
            data: payload
        })
        .then(response => response.data)
}
export function createContact(payload) {
    const url = `https://api.airtable.com/v0/appu2mfw4F1eCE4Ah/Contacts`
    return axios({
            headers: {
                Authorization: `Bearer ${key}`,
                "Content-Type": `application/json`
            },
            method: 'post',
            url,
            data: payload
        })
        .then(response => response.data)
}
export function createGeneralRequest(payload) {
    const url = `https://api.airtable.com/v0/appu2mfw4F1eCE4Ah/General%20Requests`
    return axios({
            headers: {
                Authorization: `Bearer ${key}`,
                "Content-Type": `application/json`
            },
            method: 'post',
            url,
            data: payload
        })
        .then(response => response.data)
}
export function createTechnicalGuideRequest(payload) {
    const url = `https://api.airtable.com/v0/appu2mfw4F1eCE4Ah/Technical%20Guide%20Request`
    return axios({
            headers: {
                Authorization: `Bearer ${key}`,
                "Content-Type": `application/json`
            },
            method: 'post',
            url,
            data: payload
        })
        .then(response => response.data)
}
export function generalRequest({
    email,
    country,
    projectType,
    company,
    message
}) {
    return createCompany({
        "fields": {
            "Company": company,
            "Country": country
        }
    }).then(resCompany => {
        return createContact({
            "fields": {
                "Email": email,
                "Company": [resCompany.id]
            }
        }).then(resContact => {
            return createGeneralRequest({
                "fields": {
                    "Message": message,
                    "Project Type": projectType,
                    "Contact": [resContact.id]
                }
            })
        })
    })
}
export function technicalGuideRequest({
    lastname,
    firstname,
    jobtitle,
    email,
    country,
    company,
    address,
    zip,
    town,
    copies,
    language
}) {
    return createCompany({
        "fields": {
            "Company": company,
            "Country": country,
            "City": town,
            "ZIP": zip,
            "Address": address
        }
    }).then(resCompany => {
        return createContact({
            "fields": {
                "Email": email,
                "Full Name": `${firstname} ${lastname}`,
                "Job Title": jobtitle,
                "Company": [resCompany.id]
            }
        }).then(resContact => {
            return createTechnicalGuideRequest({
                "fields": {
                    "Copies": copies,
                    "Language": language,
                    "Contact": [resContact.id]
                },
                "typecast": true
            })
        })
    })
}